import * as Tabs from '@radix-ui/react-tabs';
import { motion, AnimatePresence } from 'framer-motion';
import { Tooltip } from "react-tooltip";
import { useEffect } from 'react';


interface ProjectTabsProps {
  children: React.ReactNode;
  activeTab: string;
  isUnityExists: boolean;
  profileProducts: any[];
  onTabChange: (value: string) => void;
}

const ProjectTabs = ({ children, activeTab, onTabChange, profileProducts, isUnityExists }: ProjectTabsProps) => {


  return (
    <div>
      <Tabs.Root value={activeTab} onValueChange={onTabChange}>
        <div className="sticky top-0  z-20">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-xl font-semibold text-white">Projects </h1>
          </div>
          {/* <Tabs.List className="flex w-full">
            {profileProducts.length > 0 && profileProducts.map((product: any) => {
              return (
                <Tabs.Trigger
                  data-tooltip-id={isUnityExists && product.name.includes("Operational Excellence") && "view-operational-excellence"}
                  data-tooltip-content={
                    isUnityExists && product.name.includes("Operational Excellence") 
                      ? "To access the Operational Excellence projects, please open them in the browser by clicking here"
                      : ""
                  }
                  data-tooltip-html={
                    isUnityExists && product.name.includes("Operational Excellence")
                      ? "To access the Operational Excellence projects, please open them in the browser by <a id='view-operational-excellence' href='#' style='color: #65f4cd; text-decoration: underline; cursor: pointer;'>Clicking Here</a>"
                      : ""
                  }
                  disabled={isUnityExists ? product.name.includes("Operational Excellence") : false}
                  key={product.id}
                  value={product.id}
                  className={`px-6 py-2.5 text-sm transition-colors ${isUnityExists && product.name.includes("Operational Excellence") && "opacity-[.8]"} relative flex-1 max-w-[200px] ${activeTab === product.id
                    ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] text-white rounded-lg'
                    : 'bg-[#2A2A2A] text-gray-400 rounded-lg'
                    }`}
                >
                  {product.name}
                </Tabs.Trigger>
              );
            })}
            <div className="flex-1 bg-[#2A2A2A] h-full" />
          </Tabs.List> */}
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.15 }}
          >
            {children}
          </motion.div>
        </AnimatePresence>
      </Tabs.Root>
      <Tooltip
        id="view-operational-excellence"
        place="top"
        className="bg-[#1A1A1A] z-50 w-[20px] border border-white/[0.08] !opacity-100"
        positionStrategy="fixed"
        style={{
          fontSize: '0.875rem',
          padding: '0.5rem 0.75rem',
          width: "250px"
        }}
        clickable={true}
      />
    </div>
  );
};

export default ProjectTabs;
